/**
 * 로또 당첨금에 대한 세금을 계산합니다.
 *
 * @param winningAmount 총 당첨금.
 * @returns 총 당첨금, 세금, 실수령액을 포함하는 객체.
 */
export const calculateLottoTax = (winningAmount: number): {
  totalWinnings: number;
  taxAmount: number;
  netWinnings: number;
} => {
  let taxAmount = 0;
  const taxRate1 = 0.22; // 3억 원 이하 세율
  const taxRate2 = 0.33; // 3억 원 초과 세율
  const taxThreshold = 300000000; // 3억 원
  const taxExemptionLimit = 2000000; // 비과세 한도

  if (winningAmount <= taxExemptionLimit) {
    taxAmount = 0;
  } else if (winningAmount > taxExemptionLimit && winningAmount <= taxThreshold) {
    taxAmount = winningAmount * taxRate1;
  } else {
    const taxForFirst300M = taxThreshold * taxRate1;
    const amountOver300M = winningAmount - taxThreshold;
    const taxForAmountOver300M = amountOver300M * taxRate2;
    taxAmount = taxForFirst300M + taxForAmountOver300M;
  }

  const netWinnings = winningAmount - taxAmount;

  return {
    totalWinnings: winningAmount,
    taxAmount: Math.floor(taxAmount), // 소수점 버림
    netWinnings: Math.floor(netWinnings), // 소수점 버림
  };
};
